/* eslint-disable indent */
/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import {
  Typography,
} from '@material-ui/core';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';

const Assistance = () => (
  <Button
    target="_blank"
    color="secondary"
    href="https://englishworld.atlassian.net/servicedesk/customer/portal/6"
    style={{
        marginTop: '35px',
        backgroundColor: '#92b4f5',
        width: '66%',
        marginLeft: '16.5%',
        color: 'white',
        '&:hover': {
          backgroundColor: '#466bb4',
          color: 'white',
        },
      }}
  >
    <Typography variant="h6" style={{ color: 'white' }}>
      {'Besoin d\'aide ? Assistance'}
    </Typography>
  </Button>
  );

export default connect(null, null)(Assistance);
